export const getRangeDate = (name, value, format = null) => {
  return {
    [`${name}[after]`]: value && value[0].startOf('day').format(format),
    [`${name}[before]`]: value && value[1].endOf('day').format(format),
  };
};
